import { Form, message, Modal, Space } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { forgotPin } from '../../../../Services/AuthenticationServices/AuthenticationServices';
import PinInput from '../../../Common/Components/PinInput';
import './index.css';
interface IForgotPasswordProps {
  token: string;
}

const ForgotPassword: React.FC<IForgotPasswordProps> = ({ token }) => {
  const [form] = Form.useForm();
  const [visible, setVisibility] = useState(true);
  const { t } = useTranslation();

  const forgotPasswordUpdate = (value: any) => {
    forgotPin(value.newPin, token).then(() => {
      form.resetFields();
      setVisibility(false);
      message.success('Password reset successfully');
    });
  };

  const [updatedPin, setUpdatePin] = useState({
    newPin: '',
    confirmNewPin: '',
  });

  const checkConfirmPassword = (_: any, value: string) => {
    if (value && value !== updatedPin.newPin && value.length < 8)
      return Promise.reject(new Error("Password doesn't match"));
    return Promise.resolve();
  };

  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 14 },
  };

  const onOk = () => {
    form.submit();
  };

  const onCancel = () => {
    setVisibility(false);
  };

  return (
    <Modal
      title='Reset Password'
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      okButtonProps={{ danger: true }}
      okText={t('Reset PIN')}
    >
      <Form
        {...layout}
        form={form}
        name='basic'
        onFinish={forgotPasswordUpdate}
        autoComplete='off'
        scrollToFirstError={true}
      >
        <Space direction='vertical' className='spacePIN'>
          <PinInput
            label='New Password'
            nameField='newPin'
            // tslint:disable-next-line: jsx-no-lambda
            onChange={(pin) => setUpdatePin((old) => ({ ...old, newPin: pin }))}
          />
          <PinInput
            label='Confirm New Password'
            nameField='confirmNewPin'
            customRule={checkConfirmPassword}
            // tslint:disable-next-line: jsx-no-lambda
            onChange={(pin) =>
              setUpdatePin((old) => ({ ...old, confirmNewPin: pin }))
            }
          />
        </Space>
      </Form>
    </Modal>
  );
};
export default ForgotPassword;
